var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgInfo = function SvgInfo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 13,
    rx: 6.5,
    stroke: "#DCDFE7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.71088 11C6.63088 11 6.56288 10.976 6.50688 10.928C6.45888 10.872 6.43488 10.804 6.43488 10.724V5.036C6.43488 4.956 6.45888 4.892 6.50688 4.844C6.56288 4.788 6.63088 4.76 6.71088 4.76H7.28688C7.36688 4.76 7.43088 4.788 7.47888 4.844C7.52688 4.892 7.55088 4.956 7.55088 5.036V10.724C7.55088 10.804 7.52688 10.872 7.47888 10.928C7.43088 10.976 7.36688 11 7.28688 11H6.71088ZM6.61488 3.596C6.53488 3.596 6.46688 3.572 6.41088 3.524C6.36288 3.468 6.33887 3.4 6.33887 3.32V2.672C6.33887 2.592 6.36288 2.528 6.41088 2.48C6.46688 2.424 6.53488 2.396 6.61488 2.396H7.37088C7.45088 2.396 7.51488 2.424 7.56288 2.48C7.61888 2.528 7.64688 2.592 7.64688 2.672V3.32C7.64688 3.4 7.61888 3.468 7.56288 3.524C7.51488 3.572 7.45088 3.596 7.37088 3.596H6.61488Z",
    fill: "black"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Info.0a33f01bf8750887915098a04eff28ce.svg";